import {
  Balance,
  List,
  ListItem,
  SuitabilityBadge,
  Text,
  Tooltip,
  HStack,
  VStack,
} from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { CustomerWalletPoints } from '../../../../../components/CustomerWalletPoints';
import { CustomerItemSelectedProps } from '../models';

export const TabletCustomerItemSelected: React.FC<CustomerItemSelectedProps> = (props) => {
  return (
    <List testId="selected-customer" height={108}>
      <HStack alignItems={'center'} space={Spacing['inline.nano']}>
        <Tooltip testID="qa" label={props.customerItem.suitabilityProfileName || ''}>
          <SuitabilityBadge label={props.customerItem.suitabilityProfileName || ''} hideText />
        </Tooltip>
        <VStack space="stack.quarck">
          <Text variant="semibold" color="neutral.black" numberOfLines={1} flex={1}>
            {props.customerItem.name}
          </Text>
          <Text fontSize="xs" color="neutral.black" numberOfLines={1} flex={1}>
            {Utils.Mask.CpfOrCnpj(props.customerItem.cpfCnpjFormatted)}
          </Text>
        </VStack>
      </HStack>
      <ListItem testId="selected-customer-registration-status-name" title="Cadastro">
        {props.customerItem.registrationStatusName}
      </ListItem>
      <ListItem testId="selected-customer-points" title="Pts na carteira">
        <CustomerWalletPoints accountNumber={props.customerItem.accountNumber} />
      </ListItem>
      <ListItem testId="selected-customer-available-balance" title="Saldo disponível">
        <Balance
          testId="selected-customer-available-balance"
          value={props.customerItem.availableBalance}
          isLoading={props.isLoadingBalance}
          onUpdate={() => props.handleUpdateBalance(props.customerItem)}
        />
      </ListItem>
      <VStack alignItems={'flex-end'} w={'130px'}>
        <Text lineHeight="distant" fontSize={Typography['fontsize.md']} variant="semibold">
          Saldo estimado
        </Text>
        <Box alignItems={'flex-end'}>
          <Text
            lineHeight="distant"
            fontSize={Typography['fontsize.md']}
            variant="regular"
            numberOfLines={1}
            {...(props.estimatedValue.startsWith('-') && { color: 'feedback.error.default' })}>
            {props.estimatedValue}
          </Text>
          <Text
            color="neutral.light"
            lineHeight="medium"
            fontSize={Typography['fontsize.xs']}
            variant="regular">
            Após investimento
          </Text>
        </Box>
      </VStack>
    </List>
  );
};
